module.exports = __webpack_public_path__ + "static/media/oberflex-eucalyptus-1200x2490.04d45802.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-eucalyptus-1200x2490.jpg
// module id = 1006
// module chunks = 37